/*  BookMarker — Starter File
    This application simulates an electronic bookmark list. Users can add and delete
    bookmarks from the list. The list of bookmarks is stored in browser local storage
    so bookmarks persist between sessions.

    Adapted by Brian Bird from starter files by Mari Good, winter 2024.
    Updated and refactored by Brian Bird using GitHub Copilot spring 2026.
    All classes and initialization code are in this single file.
*/
import { BookmarkModel } from './model.js';
import { BookmarkView } from './view.js';
import { BookmarkController } from './controller.js';

/* ========== Initialization ========== */
//Blake Gilmore 4/25 AI used to figure out lit-html
/**
 * Delays app startup until the DOM is fully parsed so the view's
 * querySelector calls always find their target elements before the
 * controller wires up events.
 */
document.addEventListener('DOMContentLoaded', () => {
  // Wait for the DOM so view selectors always resolve before wiring events.
  new BookmarkController(new BookmarkModel(), new BookmarkView());
});

